import { combineReducers } from 'redux';
import { REDUCERS } from '../constants';
import onlineCancel from './onlineCancel';
import orderTracking from './orderTracking';
import orderActions, * as fromOrderActions from './orderActions';
import device from './device';
import returnService from './returns';
import trackingDetails from './trackingDetails';

const orderApp = combineReducers({
  onlineCancel,
  returnService,
  orderTracking,
  trackingDetails,
  [REDUCERS.ORDER_HISTORY]: orderActions(REDUCERS.ORDER_HISTORY),
  [REDUCERS.ORDER_DETAILS]: orderActions(REDUCERS.ORDER_DETAILS),
  [REDUCERS.STH_TRACKING]: orderActions(REDUCERS.STH_TRACKING),
  [REDUCERS.BOSS_TRACKING]: orderActions(REDUCERS.BOSS_TRACKING),
  [REDUCERS.BODFS_TRACKING]: orderActions(REDUCERS.BODFS_TRACKING),
  [REDUCERS.APPLIANCE_ACTION]: orderActions(REDUCERS.APPLIANCE_ACTION),
  [REDUCERS.ERECEIPTS_SUMMARY]: orderActions(REDUCERS.ERECEIPTS_SUMMARY),
  device,
});

export default orderApp;

// selectors

export const getActionData = (
  state: Object,
  filter: string,
  orderId: string = ''
) => fromOrderActions.getActionData(state[filter], orderId);

export const getMappedData = (
  state: Object,
  filter: string,
  orderId: string = ''
) => fromOrderActions.getMappedData(state[filter], orderId);

export const getIsFetching = (
  state: Object,
  filter: string,
  orderId: string = ''
) => fromOrderActions.getIsFetching(state[filter], orderId);

export const getOpenModal = (
  state: Object,
  filter: string,
  orderId: string = ''
) => fromOrderActions.getOpenModal(state[filter], orderId);

export const getErrorMessage = (
  state: Object,
  filter: string,
  orderId: string = ''
) => fromOrderActions.getErrorMessage(state[filter], orderId);

export const getDevice = (state: Object, filter: string) =>
  state.device[filter];

export const getOrderGroup = (
  state: Object,
  orderId: string,
  groupIndex: Number
) => {
  const order = getActionData(state, REDUCERS.ORDER_DETAILS, orderId);
  return order.orderGroups[groupIndex];
};

export const getOrderLineItems = (state: Object, orderId: string) =>
  fromOrderActions.getOrderLineItems(state.orderDetails, orderId);

export const getOrderRefNumber = (state: Object, orderId: string) =>
  fromOrderActions.getOrderRefNumber(state.orderDetails, orderId);

export const getIsInstoreOrder = (state: Object, orderId: string) =>
  fromOrderActions.getIsInstore(state.orderDetails, orderId);
